import React from 'react';
import { RuleGraphFullRelease } from "@/components/RuleGraph_FullRelease";
import { useGraphVisualisation } from "../hooks/useGraphVisualisation";

/**
 * TODO: should refactor into a single unified graph for debug and non-debug graph. but will wait until new designs are done
 */

// The renderer lays out only the nodes it draws (bounded by the render limit / restricted view), from the decision
// graph and the view's mask: nothing is written out for the whole graph here.
const MemoisedGraph = React.memo(({ graph, visible, debug, setSelectedNodeId, setRestrictedViewRootPath }) => {
  return (
    <RuleGraphFullRelease
      onNodeClick={setSelectedNodeId}
      graph={graph}
      visible={visible}
      typeFunc={debug ? 'byValue' : undefined}
      showHidden={!debug}
      onNodeCtrlClick={setRestrictedViewRootPath}
    />
  )
});
const Classic = () => {
  const { graph, visible, setSelectedNodeId, debug, graphVizType, setRestrictedViewRootPath } = useGraphVisualisation();
  if (!graph) return null;
  return (
    <MemoisedGraph
      key={graphVizType}
      graph={graph}
      visible={visible}
      debug={debug}
      setSelectedNodeId={setSelectedNodeId}
      setRestrictedViewRootPath={setRestrictedViewRootPath}
    />
  )
}

export default Classic;
